export class Utilisateur {

    idutilisateur: string;
    login: string;
    password: string;
    idclient: string;
    desactive: boolean;

}


// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/utilisateur.model.ts